<template>
  <el-dialog :title="title" :visible="visible" width="500px" :close-on-click-modal="false" :before-close="handleClose"  @open="getEditForm()">
    <el-form :model="editForm" :rules="rules" ref="editForm" style="width: 400px" label-width="100px">
      <el-form-item prop="username" label="用户名">
        <p v-if="id">{{editForm.username}}</p>
        <el-input v-model="editForm.username" placeholder="请输入用户名" auto-complete="off" v-else></el-input>
      </el-form-item>
      <el-form-item prop="name" label="姓名">
        <el-input v-model="editForm.name" placeholder="请输入姓名" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码" v-if="id === ''">
        <el-input type="password" v-model="editForm.password" placeholder="请输入密码" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item prop="status" label="状态">
        <el-radio v-model="editForm.status" :label="1">启用</el-radio>
        <el-radio v-model="editForm.status" :label="0">停用</el-radio>
      </el-form-item>
      <el-form-item prop="remark" label="备注">
        <el-input type="textarea" v-model="editForm.remark" placeholder="请输入备注" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: String
  },
  data () {
    return {
      title: '用户信息',
      editForm: {
        name: '',
        status: 1
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getEditForm () {
      this.$refs.editForm?.resetFields();
      if (this.id) {
        this.title = '修改用户'
        this.$api.system.getUserInfo(this.id).then(res => {
          if (res.code === 200) {
            this.editForm = {
              username: res.data.username,
              name: res.data.name,
              status: res.data.status,
              remark: res.data.remark
            }
          } else {
            this.$message.error(res.message)
            this.handleClose()
          }
        })
      } else {
        this.title = '增加用户'
        this.editForm = { status: 1 }
      }
    },
    handleClose () {
      this.$emit('close')
    },
    handleSave () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$api.system.saveUserInfo(this.id, this.editForm).then(res => {
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.$emit('close', true)
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
